import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

const CSV_EXTENSION = '.csv';
const FORMATO_DATA_BR = /^(\d{2})\/(\d{2})\/(\d{4})$/;
const FORMATO_DATA_ISO = /^(\d{4})\/(\d{2})\/(\d{2})$/;

function detectarSeparadorCsv(texto) {
    const primeiraLinha = String(texto || '').split(/\r?\n/).find(linha => linha.trim() !== '') || '';
    const qtdPontoVirgula = (primeiraLinha.match(/;/g) || []).length;
    const qtdVirgula = (primeiraLinha.match(/,/g) || []).length;
    return qtdPontoVirgula > qtdVirgula ? ';' : ',';
}

function pareceCsv(texto) {
    const amostra = String(texto || '').slice(0, 4096);
    if (!amostra || amostra.charCodeAt(0) === 0x50) {
        // PK… = ZIP/XLSX
        return false;
    }
    return amostra.includes(',') || amostra.includes(';') || amostra.includes('\n');
}

function dataCalendarioValida(dia, mes, ano) {
    if (!Number.isInteger(dia) || !Number.isInteger(mes) || !Number.isInteger(ano)) {
        return false;
    }
    if (ano < 1000 || ano > 9999 || mes < 1 || mes > 12 || dia < 1) {
        return false;
    }
    const data = new Date(ano, mes - 1, dia);
    return (
        data.getFullYear() === ano &&
        data.getMonth() === mes - 1 &&
        data.getDate() === dia
    );
}

function normalizarCelula(valor) {
    if (valor === null || valor === undefined) {
        return '';
    }

    // Só trata como data texto estrito dd/mm/yyyy ou yyyy/mm/dd (sem letras) e calendário válido.
    const texto = typeof valor === 'string' ? valor.trim() : String(valor).trim();

    if (/[a-zA-Z]/.test(texto)) {
        return typeof valor === 'string' ? valor : texto;
    }

    const br = texto.match(FORMATO_DATA_BR);
    if (br) {
        const dia = Number(br[1]);
        const mes = Number(br[2]);
        const ano = Number(br[3]);
        if (dataCalendarioValida(dia, mes, ano)) {
            return texto;
        }
        return typeof valor === 'string' ? valor : texto;
    }

    const iso = texto.match(FORMATO_DATA_ISO);
    if (iso) {
        const ano = Number(iso[1]);
        const mes = Number(iso[2]);
        const dia = Number(iso[3]);
        if (dataCalendarioValida(dia, mes, ano)) {
            return `${String(dia).padStart(2, '0')}/${String(mes).padStart(2, '0')}/${ano}`;
        }
        return typeof valor === 'string' ? valor : texto;
    }

    return typeof valor === 'string' ? valor : texto;
}

class ExcelService {
    importFromFile(bstr, sheet) {
        /* read workbook */
        console.log("bstr:", bstr);

        const opcoesLeitura = {
            type: 'binary',
            cellDates: false,
            raw: true
        };

        if (pareceCsv(bstr)) {
            opcoesLeitura.FS = detectarSeparadorCsv(bstr);
        }

        const wb = XLSX.read(bstr, opcoesLeitura);

        /* grab first sheet */
        const wsname = wb.SheetNames[sheet];
        const ws = wb.Sheets[wsname];

        /* save data — raw:true evita dateNF formatando células mal classificadas */
        const data = XLSX.utils.sheet_to_json(ws, {
            header: 1,
            raw: true,
            defval: ''
        });

        return data.map(row => (
            Array.isArray(row) ? row.map(normalizarCelula) : row
        ));
    }

    saveAsCsvFile(data, fileName, delimiter = ';') {
        const worksheet = XLSX.utils.json_to_sheet(data);
        const csvOutput = XLSX.utils.sheet_to_csv(worksheet, {FS: delimiter});
        const blob = new Blob(['\ufeff', csvOutput], { type: 'text/plain; charset=ISO-8859-1' });
        FileSaver.saveAs(
          blob,
          fileName + '_export_' + new Date().getTime() + CSV_EXTENSION);
      }

  }
  
  export default new ExcelService();
